import { Component } from '@angular/core';

@Component({
    selector: 'bb-account-selector-page-ui',
    template: '',
    styles: [],
    standalone: false,
})
export class AccountSelectorPageComponent {}
